import { render, staticRenderFns } from "./EmoteGraphic.vue?vue&type=template&id=3afd9314&functional=true&"
import script from "./EmoteGraphic.vue?vue&type=script&lang=js&"
export * from "./EmoteGraphic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports